// App

// 3rd-party Libraries

import 'minireset.css';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

// Application Globals

import './globals/base/';
import './globals/fonts/';
import './globals/images/';

// Application Widgets

import Application from './widgets/application/';
import './widgets/block/';
import './widgets/richtext/';
import './widgets/tag/';
import './widgets/site/';
import SiteHeader from './widgets/site-header/';
import SiteFooter from './widgets/site-footer/';
import './widgets/hero-image/';
import './widgets/widget/';
import WidgetAccordion from './widgets/widget-accordion/';
import './widgets/widget-facts/';
import './widgets/widget-image-with-text/';
import OffersList from './widgets/widget-joboffer-list/';
import WidgetTabs from './widgets/widget-tabs/';
import './widgets/widget-teaser-boxes/';
import WidgetImageTeasers from './widgets/widget-image-teasers/';

import FallbackJobofferBox from './widgets/fallback-joboffer-box/';
import Form from './widgets/form/';
import './widgets/form-error-message/';
import './widgets/form-success-message/';
import PageJoboffer from './widgets/page-joboffer/';
import './widgets/page-joboffer-list/';
import Popup from './widgets/popup/';

// Application

class App extends Application {
  constructor() {
    super();
  }

  // Event Handlers: Ready State Change

  handleReadyStateInteractive() {
    super.handleReadyStateInteractive();

    let siteHeader = document.querySelector('.site-header');
    if (siteHeader) { this.siteHeader = new SiteHeader(siteHeader); }

    let siteFooter = document.querySelector('.site-footer');
    if (siteFooter) { this.siteFooter = new SiteFooter(siteFooter); }

    this.accordions = [];
    document.querySelectorAll('.widget-accordion').forEach((element) => {
      this.accordions.push(new WidgetAccordion(element));
    });

    let offersList = document.querySelector('.offers-list-with-filters');
    if (offersList) { this.offersList = new OffersList(offersList); }

    this.widgetTabsList = [];
    document.querySelectorAll('.widget-tabs').forEach((element) => {
      this.widgetTabsList.push(new WidgetTabs(element));
    });

    this.widgetImageTeasersList = [];
    document.querySelectorAll('.widget-image-teasers').forEach((element) => {
      this.widgetImageTeasersList.push(new WidgetImageTeasers(element));
    });

    let pageJoboffer = document.querySelector('#page-joboffer');
    if (pageJoboffer) { this.pageJoboffer = new PageJoboffer(pageJoboffer); }

    let fallbackJobofferBox = document.querySelector('.widget-fallback-joboffer-box');
    if (fallbackJobofferBox) { this.fallbackJobofferBox = new FallbackJobofferBox(fallbackJobofferBox); }

    this.popups = [];
    document.querySelectorAll('.popup').forEach((popup) => {
        this.popups.push(new Popup(popup));
    });

    this.forms = [];
    document.querySelectorAll('.app-form').forEach((form) => {
        this.forms.push(new Form(form));
    });

    document.querySelectorAll('a[data-href]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();

        window.location = link.href + '#' + link.dataset.href;
      });
    });

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();

        const url = new URL(event.target.closest('a').href);
        app.scrollToHash(url.hash);
      });
    });

    if (this.pageJoboffer) {
      let reopen = this.reopenPopup();
      if (reopen) {
        this.pageJoboffer.trackFormSend();
      } else {
        this.pageJoboffer.trackPageOpen();
      }
    }

    if (this.fallbackJobofferBox) {
      let reopen = this.reopenPopup();
    }
  }

  handleReadyStateComplete() {
    super.handleReadyStateComplete();
  }

  // Event Handlers: Resize

  handleResize() {
    super.handleResize();

    if (this.pageJoboffer) { this.pageJoboffer.resize(); }
  }

  handleResizeFinished() {
    super.handleResizeFinished();
  }

  // Event Handlers: Scroll

  handleScroll(event) {
    super.handleScroll();

    if (this.siteHeader) { this.siteHeader.scroll(); }
    if (this.pageJoboffer) { this.pageJoboffer.scroll(); }
  }

  handleScrollFinished() {
    super.handleScrollFinished();
  }

  // Helpers

  reopenPopup() {
    let reopen = false;

    const url = new URL(window.location.href);
    if (!url.hash) { return reopen; }

    const form = document.querySelector(url.hash);
    if (!form) { return reopen; }

    this.popups.forEach((popup) => {
      if (popup.root.contains(form)) {
        popup.open();
        reopen = true;
      }
    });

    return reopen;
  }
}

window.app = new App();
